/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AddGroupContactResponse,
  AddGroupContact: (params: vp.AddGroupContactRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAddGroupContact: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAddGroupContact, setShouldAddGroupContact] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AddGroupContactRequest>({
    GroupID: "",
    Token: "",
  });
  const [response, setResponse] = useState<vp.AddGroupContactResponse>({
    Success: false,
    ErrorMessage: '',
    ContactID: '',
  });

  useEffect(() => {
    if (!shouldAddGroupContact) return () => {};

    const PostAddGroupContact = async () => {
      setDataFetchingInfo(true, 'adding group', 'fullScreen');
      const res = await api.postAddGroupContact(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAddGroupContact) void PostAddGroupContact();
    setShouldAddGroupContact(false);
    return () => {
      source.cancel();
    };
  }, [shouldAddGroupContact]);

  return [
    response,
    (_params: vp.AddGroupContactRequest) => {
      setParams(_params);
      setShouldAddGroupContact(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        ContactID: '',
      });
      setShouldAddGroupContact(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAddGroupContact);